export default __webpack_public_path__ + "static/media/property-placeholder-image.9da9e08b.svg";